/*
 * @Description:
 * @Date: 2022-01-15 18:06:40
 */

export default (store, to) => {
  // 非项目结算管理则清空
  if (to.name !== 'projectSettledList') {
    store.commit('projectSettled/SET_SETTLED', {});
  }
};
